import React from "react";
import { Typography } from "@mui/material";
import TranslationContent from "../../../../Translations/TranslationContent";


const InvalidString = () => {
  return <Typography sx={{color: "black"}} variant="body2"><TranslationContent contentID="invalidStringDesc" /></Typography>
}

export default InvalidString;